var legend = {
  "display": "block",
  "width": "100%",
  "padding": "0",
  "marginBottom": "0.5rem",
  "fontSize": "1.5rem",
  "lineHeight": "inherit"
};

export { legend };
